import { render, staticRenderFns } from "./MoleculeEditionAcademyLegalsSubMenu.vue?vue&type=template&id=7f919fd1&"
import script from "./MoleculeEditionAcademyLegalsSubMenu.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAcademyLegalsSubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports